import { v4 as uuidv4 } from 'uuid'

const BASKET = 'basket'
const SESSION = 'session'
const COMMERCIAL_DISCOUNT = 'commercialDiscount'

// Only 'resident' is supported today, more discount types are expected later.
export const commercialDiscounts = ['resident'] as const
export type CommercialDiscount = (typeof commercialDiscounts)[number]

export const isCommercialDiscount = (value: string | null | undefined): value is CommercialDiscount =>
  !!value && commercialDiscounts.includes(value.toLowerCase() as CommercialDiscount)

export const setSessionBasket = (basketId: string): void => sessionStorage.setItem(BASKET, JSON.stringify({ basketId: basketId }))
export const getSessionBasket = (): { basketId: string } => sessionStorage[BASKET] && JSON.parse(sessionStorage[BASKET])

export const setSessionCommercialDiscount = (commercialDiscount: CommercialDiscount | null): void => {
  if (commercialDiscount) sessionStorage.setItem(COMMERCIAL_DISCOUNT, commercialDiscount)
  else sessionStorage.removeItem(COMMERCIAL_DISCOUNT)
}

export const getSessionCommercialDiscount = (): CommercialDiscount | null => {
  if (typeof sessionStorage === 'undefined') return null
  const value = sessionStorage.getItem(COMMERCIAL_DISCOUNT)
  return isCommercialDiscount(value) ? (value.toLowerCase() as CommercialDiscount) : null
}

/**
 * Sets the session ID in sessionStorage. If no sessionId is provided,
 * it retrieves the current session ID or generates a new one.
 *
 * @param sessionId - The session ID to set (optional).
 */
export const setSession = (sessionId?: string): { sessionId: string } => {
  if (!sessionId) {
    const _sessionId = getSession()?.sessionId
    sessionId = _sessionId || uuidv4()
  }
  sessionStorage.setItem(SESSION, JSON.stringify({ sessionId }))
  return { sessionId }
}

export const getSession = (): { sessionId?: string } => sessionStorage[SESSION] && JSON.parse(sessionStorage[SESSION])
